module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_67-72c4ea0f17bebd55fac48aec6ea5b3f7.png";